import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import loginService from '../../services/login';
import servicioUsuario from '../../services/usuarios';
import ModalRegistro from "./ModalRegistro";
import {
  Button,
  Grid,
  TextField,
  Typography,
  CircularProgress,
  Paper,
    Snackbar,
  Backdrop
} from "@mui/material";
import logo from '../../Assets/azul.png'; // Asegurate que el archivo esté en esa ruta
import MuiAlert from '@mui/material/Alert';
import pelota from '../../Assets/pelota.gif'; // Pelota girando
const Login = () => {
    const [openRegistro, setOpenRegistro] = useState(false);
      const [formData, setFormData] = useState({
    nombre: "",
    usuario: "",
    email: "",
    password: "",
    confirmPassword: "",
  });
  const [usuario, setUsuario] = useState({
    usuario: "",
    password: "",
  });
  const [user, setUser] = useState(null);
    const [mensaje, setMensaje] = useState({ tipo: "", texto: "" });
    const [openMensaje, setOpenMensaje] = useState(false);
      const [mostrandoPelota, setMostrandoPelota] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const params = useParams();
const handleRegister = async () => {
    setMostrandoPelota(true);
    try {
      const [yyyy, mm, dd] = formData.fecha_nacimiento.split("-");
   const fechaFormateada = `${dd}/${mm}/${yyyy}`;

      const datosAEnviar = {
        ...formData,
        fecha_nacimiento: fechaFormateada,
      };

      const rta = await loginService.registro(datosAEnviar);

      setMensaje({ tipo: "success", texto: "¡Registro exitoso!" });
      setOpenMensaje(true);
      setOpenRegistro(false);
    } catch (error) {
      let texto = "Error desconocido.";
      if (error.response) {
        texto = error.response.data.message || 'Algo salió mal.';
      } else if (error.request) {
        texto = 'No se pudo conectar con el servidor.';
      } else {
        texto = 'Error inesperado: ' + error.message;
      }
      setMensaje({ tipo: "error", texto });
      setOpenMensaje(true);
    } finally {
      setMostrandoPelota(false);
    }
  };

 const loginSubmit = async (event) => {
   setMostrandoPelota(true);
  event.preventDefault();
  setLoading(true);

  try {
    const user = await loginService.login({
      usuario: usuario.usuario,
      password: usuario.password,
    });

    localStorage.setItem("loggedNoteAppUser", JSON.stringify(user));
    servicioUsuario.setToken(user.token);
    setUser(user);

    const nivel = Number(user.nivel); // 👈 Forzamos número
    console.log("Nivel detectado:", nivel);
 setMostrandoPelota(false);
    switch (nivel) {
      case 1:
        console.log("Redirigiendo a /");
        navigate("/falta1/principal");
        break;
      default:
        ////localStorage.removeItem("loggedNoteAppUser");
        //navigate("/login");
    }
  } catch (error) {
    alert("Credenciales incorrectas o error de conexión.");
  } finally {
    setLoading(false);
  }
};


  const handleChange = (e) => {
    setUsuario({ ...usuario, [e.target.name]: e.target.value });
  };

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      style={{
        minHeight: "100vh",
        background: "#06437c",
        fontFamily: "'Montserrat', sans-serif"
      }}
    >
      <Paper
        elevation={10}
        style={{
          padding: 24,
          width: "90%",
          maxWidth: 360,
          borderRadius: 20,
          background: "#fff",
          boxSizing: "border-box",
        }}
      >
        <Grid align="center">
          <img
            src={logo}
            alt="Logo App"
            style={{ width: 100, height: 100, objectFit: "contain", marginBottom: 12 }}
          />
          <Typography variant="h6" style={{ fontWeight: 700, color: "#04305a" }}>
            ¡Organizá tu partido de fútbol!
          </Typography>
          <Typography variant="body2" style={{ color: "#0862b6", marginBottom: 16 }}>
            ¿Tenés equipo? ¿Estás solo? ¿Te falta uno o un rival?
          </Typography>
        </Grid>

        <form onSubmit={loginSubmit}>
          <TextField
            fullWidth
            label="Usuario"
            name="usuario"
            variant="outlined"
            margin="dense"
            onChange={handleChange}
            value={usuario.usuario}
          />
          <TextField
            fullWidth
            label="Contraseña"
            type="password"
            name="password"
            variant="outlined"
            margin="dense"
            onChange={handleChange}
            value={usuario.password}
          />
          <Button
            type="submit"
            variant="contained"
            fullWidth
            style={{
              backgroundColor: "#4CAF50",
              marginTop: 16,
              color: "white",
              fontWeight: "bold",
              borderRadius: 8,
            }}
          >
            {loading ? <CircularProgress size={24} color="inherit" /> : "INGRESAR"}
          </Button>
          <Button
  variant="outlined"
  fullWidth
  onClick={() => navigate("/falta1/principal")}
  style={{
    marginTop: 10,
    color: "#06437c",
    borderColor: "#06437c",
    fontWeight: "bold",
    borderRadius: 8,
  }}
>
  Entrar como invitado
</Button>
        </form>

        <Button onClick={() => setOpenRegistro(true)}>¿No tenés cuenta? Registrate</Button>
        <ModalRegistro
          open={openRegistro}
          onClose={() => setOpenRegistro(false)}
          onRegister={handleRegister}
          formData={formData}
          setFormData={setFormData}
        />
        <Typography
          variant="caption"
          display="block"
          align="center"
          style={{ marginTop: 16, color: "#0d69c1" }}
        >
          Conectate con jugadores y armá tu partido en minutos.
        </Typography>
      </Paper>

      <Snackbar open={openMensaje} autoHideDuration={4000} onClose={() => setOpenMensaje(false)}>
        <MuiAlert onClose={() => setOpenMensaje(false)} severity={mensaje.tipo} sx={{ width: '100%' }}>
          {mensaje.texto}
        </MuiAlert>
      </Snackbar>

      <Backdrop open={mostrandoPelota} sx={{ zIndex: 9999, color: '#fff', flexDirection: 'column' }}>
        <img src={pelota} alt="Registrando..." style={{ width: 80, height: 80, marginBottom: 10 }} />
        <Typography variant="h6" color="white">Procesando registro...</Typography>
      </Backdrop>
    </Grid>
  );
};

export default Login;
